import ProductPrice from './ProductPrice';

export default function areProductPricesEqual(
	packPrice: ProductPrice | null,
	otherPackPrice: ProductPrice | null
): boolean {
	return (
		((packPrice === null || packPrice.price === null) && (otherPackPrice === null || otherPackPrice.price === null)) ||
		Boolean(packPrice?.price?.equals(otherPackPrice?.price))
	);
}
